import { render, staticRenderFns } from "./HoverDropdown.vue?vue&type=template&id=0f63727b&scoped=true&"
import script from "./HoverDropdown.js?vue&type=script&lang=js&"
export * from "./HoverDropdown.js?vue&type=script&lang=js&"
import style0 from "./HoverDropdown.scss?vue&type=style&index=0&id=0f63727b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63727b",
  null
  
)

export default component.exports